module.exports = __webpack_public_path__ + "static/media/sjorsgoemans.55966d64.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/sjorsgoemans.webp
// module id = 605
// module chunks = 0